/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getAddressBook = /* GraphQL */ `
  query GetAddressBook($email: String!, $userId: ID!) {
    getAddressBook(email: $email, userId: $userId) {
      email
      userId
      expiry
      __typename
    }
  }
`;
export const listAddressBooks = /* GraphQL */ `
  query ListAddressBooks(
    $email: String
    $userId: ModelIDKeyConditionInput
    $filter: ModelAddressBookFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAddressBooks(
      email: $email
      userId: $userId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        email
        userId
        expiry
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const addressBookByUserId = /* GraphQL */ `
  query AddressBookByUserId(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAddressBookFilterInput
    $limit: Int
    $nextToken: String
  ) {
    addressBookByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        email
        userId
        expiry
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchAddressBooks = /* GraphQL */ `
  query SearchAddressBooks(
    $filter: SearchableAddressBookFilterInput
    $sort: [SearchableAddressBookSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableAddressBookAggregationInput]
  ) {
    searchAddressBooks(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        email
        userId
        expiry
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getCompletedDocument = /* GraphQL */ `
  query GetCompletedDocument($id: ID!) {
    getCompletedDocument(id: $id) {
      id
      name
      pdfKey
      draft
      locked
      lockedBy {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      lockedById
      annotations
      templateId
      template {
        id
        name
        pdfKey
        summary
        fillable
        daysUntilFinalized
        folderId
        createdBy
        createdAt
        updatedBy
        updatedAt
        __typename
      }
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      creator {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      createdBy
      createdAt
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      foremanId
      updator {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      updatedBy
      updatedAt
      finalizeAfter
      authors
      __typename
    }
  }
`;
export const listCompletedDocuments = /* GraphQL */ `
  query ListCompletedDocuments(
    $id: ID
    $filter: ModelCompletedDocumentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCompletedDocuments(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        pdfKey
        draft
        locked
        lockedById
        annotations
        templateId
        locationId
        customerId
        createdBy
        createdAt
        foremanId
        updatedBy
        updatedAt
        finalizeAfter
        authors
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const completedDocumentByLockedById = /* GraphQL */ `
  query CompletedDocumentByLockedById(
    $lockedById: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompletedDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    completedDocumentByLockedById(
      lockedById: $lockedById
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        pdfKey
        draft
        locked
        lockedById
        annotations
        templateId
        locationId
        customerId
        createdBy
        createdAt
        foremanId
        updatedBy
        updatedAt
        finalizeAfter
        authors
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const completedDocumentByLocationId = /* GraphQL */ `
  query CompletedDocumentByLocationId(
    $locationId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompletedDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    completedDocumentByLocationId(
      locationId: $locationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        pdfKey
        draft
        locked
        lockedById
        annotations
        templateId
        locationId
        customerId
        createdBy
        createdAt
        foremanId
        updatedBy
        updatedAt
        finalizeAfter
        authors
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const completedDocumentByCustomerId = /* GraphQL */ `
  query CompletedDocumentByCustomerId(
    $customerId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompletedDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    completedDocumentByCustomerId(
      customerId: $customerId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        pdfKey
        draft
        locked
        lockedById
        annotations
        templateId
        locationId
        customerId
        createdBy
        createdAt
        foremanId
        updatedBy
        updatedAt
        finalizeAfter
        authors
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const completedDocumentByCrewMemberId = /* GraphQL */ `
  query CompletedDocumentByCrewMemberId(
    $createdBy: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompletedDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    completedDocumentByCrewMemberId(
      createdBy: $createdBy
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        pdfKey
        draft
        locked
        lockedById
        annotations
        templateId
        locationId
        customerId
        createdBy
        createdAt
        foremanId
        updatedBy
        updatedAt
        finalizeAfter
        authors
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const completedDocumentByForemanId = /* GraphQL */ `
  query CompletedDocumentByForemanId(
    $foremanId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompletedDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    completedDocumentByForemanId(
      foremanId: $foremanId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        pdfKey
        draft
        locked
        lockedById
        annotations
        templateId
        locationId
        customerId
        createdBy
        createdAt
        foremanId
        updatedBy
        updatedAt
        finalizeAfter
        authors
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const completedDocumentByUpdatingCrewMemberId = /* GraphQL */ `
  query CompletedDocumentByUpdatingCrewMemberId(
    $updatedBy: ID!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompletedDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    completedDocumentByUpdatingCrewMemberId(
      updatedBy: $updatedBy
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        pdfKey
        draft
        locked
        lockedById
        annotations
        templateId
        locationId
        customerId
        createdBy
        createdAt
        foremanId
        updatedBy
        updatedAt
        finalizeAfter
        authors
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchCompletedDocuments = /* GraphQL */ `
  query SearchCompletedDocuments(
    $filter: SearchableCompletedDocumentFilterInput
    $sort: [SearchableCompletedDocumentSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCompletedDocumentAggregationInput]
  ) {
    searchCompletedDocuments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        pdfKey
        draft
        locked
        lockedById
        annotations
        templateId
        locationId
        customerId
        createdBy
        createdAt
        foremanId
        updatedBy
        updatedAt
        finalizeAfter
        authors
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getCrewMember = /* GraphQL */ `
  query GetCrewMember($id: ID!, $locationId: ID!) {
    getCrewMember(id: $id, locationId: $locationId) {
      id
      active
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      rateOverride {
        crewMemberId
        locationId
        rate
        __typename
      }
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      email
      name
      rate
      crewMemberUserId
      __typename
    }
  }
`;
export const listCrewMembers = /* GraphQL */ `
  query ListCrewMembers(
    $id: ID
    $locationId: ModelIDKeyConditionInput
    $filter: ModelCrewMemberFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCrewMembers(
      id: $id
      locationId: $locationId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const crewMemberByLocationId = /* GraphQL */ `
  query CrewMemberByLocationId(
    $locationId: ID!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCrewMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    crewMemberByLocationId(
      locationId: $locationId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchCrewMembers = /* GraphQL */ `
  query SearchCrewMembers(
    $filter: SearchableCrewMemberFilterInput
    $sort: [SearchableCrewMemberSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCrewMemberAggregationInput]
  ) {
    searchCrewMembers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!, $locationId: ID!) {
    getCustomer(id: $id, locationId: $locationId) {
      id
      number
      name
      active
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      __typename
    }
  }
`;
export const listCustomers = /* GraphQL */ `
  query ListCustomers(
    $id: ID
    $locationId: ModelIDKeyConditionInput
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCustomers(
      id: $id
      locationId: $locationId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        number
        name
        active
        locationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const customerByLocationId = /* GraphQL */ `
  query CustomerByLocationId(
    $locationId: ID!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerByLocationId(
      locationId: $locationId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        number
        name
        active
        locationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchCustomers = /* GraphQL */ `
  query SearchCustomers(
    $filter: SearchableCustomerFilterInput
    $sort: [SearchableCustomerSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCustomerAggregationInput]
  ) {
    searchCustomers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        number
        name
        active
        locationId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getDailyReport = /* GraphQL */ `
  query GetDailyReport($id: ID!) {
    getDailyReport(id: $id) {
      id
      submissionDate
      summary
      isCompleted
      anyoneInjured
      qaqcCompleted
      siteSecured
      pdfKey
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      foremanId
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      media {
        nextToken
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      userId
      createdBy {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      type
      inspectionType
      foremanName
      customerName
      address
      taskArea
      weather
      correctiveActions {
        action
        dueDate
        assignedTo
        signature
        __typename
      }
      inspectionQuestion
      foremanSignature
      safetySignature
      __typename
    }
  }
`;
export const listDailyReports = /* GraphQL */ `
  query ListDailyReports(
    $id: ID
    $filter: ModelDailyReportFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDailyReports(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        submissionDate
        summary
        isCompleted
        anyoneInjured
        qaqcCompleted
        siteSecured
        pdfKey
        locationId
        foremanId
        customerId
        userId
        type
        inspectionType
        foremanName
        customerName
        address
        taskArea
        weather
        inspectionQuestion
        foremanSignature
        safetySignature
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const dailyReportByLocationId = /* GraphQL */ `
  query DailyReportByLocationId(
    $locationId: ID!
    $submissionDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDailyReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    dailyReportByLocationId(
      locationId: $locationId
      submissionDate: $submissionDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        submissionDate
        summary
        isCompleted
        anyoneInjured
        qaqcCompleted
        siteSecured
        pdfKey
        locationId
        foremanId
        customerId
        userId
        type
        inspectionType
        foremanName
        customerName
        address
        taskArea
        weather
        inspectionQuestion
        foremanSignature
        safetySignature
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const dailyReportByForemanId = /* GraphQL */ `
  query DailyReportByForemanId(
    $foremanId: ID!
    $submissionDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDailyReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    dailyReportByForemanId(
      foremanId: $foremanId
      submissionDate: $submissionDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        submissionDate
        summary
        isCompleted
        anyoneInjured
        qaqcCompleted
        siteSecured
        pdfKey
        locationId
        foremanId
        customerId
        userId
        type
        inspectionType
        foremanName
        customerName
        address
        taskArea
        weather
        inspectionQuestion
        foremanSignature
        safetySignature
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const dailyReportByCustomerId = /* GraphQL */ `
  query DailyReportByCustomerId(
    $customerId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelDailyReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    dailyReportByCustomerId(
      customerId: $customerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        submissionDate
        summary
        isCompleted
        anyoneInjured
        qaqcCompleted
        siteSecured
        pdfKey
        locationId
        foremanId
        customerId
        userId
        type
        inspectionType
        foremanName
        customerName
        address
        taskArea
        weather
        inspectionQuestion
        foremanSignature
        safetySignature
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const dailyReportByUserId = /* GraphQL */ `
  query DailyReportByUserId(
    $userId: ID!
    $submissionDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDailyReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    dailyReportByUserId(
      userId: $userId
      submissionDate: $submissionDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        submissionDate
        summary
        isCompleted
        anyoneInjured
        qaqcCompleted
        siteSecured
        pdfKey
        locationId
        foremanId
        customerId
        userId
        type
        inspectionType
        foremanName
        customerName
        address
        taskArea
        weather
        inspectionQuestion
        foremanSignature
        safetySignature
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const dailyReportByType = /* GraphQL */ `
  query DailyReportByType(
    $type: ReportType!
    $sortDirection: ModelSortDirection
    $filter: ModelDailyReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    dailyReportByType(
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        submissionDate
        summary
        isCompleted
        anyoneInjured
        qaqcCompleted
        siteSecured
        pdfKey
        locationId
        foremanId
        customerId
        userId
        type
        inspectionType
        foremanName
        customerName
        address
        taskArea
        weather
        inspectionQuestion
        foremanSignature
        safetySignature
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchDailyReports = /* GraphQL */ `
  query SearchDailyReports(
    $filter: SearchableDailyReportFilterInput
    $sort: [SearchableDailyReportSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableDailyReportAggregationInput]
  ) {
    searchDailyReports(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        submissionDate
        summary
        isCompleted
        anyoneInjured
        qaqcCompleted
        siteSecured
        pdfKey
        locationId
        foremanId
        customerId
        userId
        type
        inspectionType
        foremanName
        customerName
        address
        taskArea
        weather
        inspectionQuestion
        foremanSignature
        safetySignature
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getDocument = /* GraphQL */ `
  query GetDocument($id: ID!) {
    getDocument(id: $id) {
      id
      name
      pdfKey
      summary
      fillable
      daysUntilFinalized
      folderId
      folder {
        id
        name
        parentId
        __typename
      }
      createdBy
      creator {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updator {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      updatedBy
      updatedAt
      __typename
    }
  }
`;
export const listDocuments = /* GraphQL */ `
  query ListDocuments(
    $id: ID
    $filter: ModelDocumentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDocuments(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        pdfKey
        summary
        fillable
        daysUntilFinalized
        folderId
        createdBy
        createdAt
        updatedBy
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const documentsByFolderId = /* GraphQL */ `
  query DocumentsByFolderId(
    $folderId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    documentsByFolderId(
      folderId: $folderId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        pdfKey
        summary
        fillable
        daysUntilFinalized
        folderId
        createdBy
        createdAt
        updatedBy
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchDocuments = /* GraphQL */ `
  query SearchDocuments(
    $filter: SearchableDocumentFilterInput
    $sort: [SearchableDocumentSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableDocumentAggregationInput]
  ) {
    searchDocuments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        pdfKey
        summary
        fillable
        daysUntilFinalized
        folderId
        createdBy
        createdAt
        updatedBy
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getFolder = /* GraphQL */ `
  query GetFolder($id: ID!) {
    getFolder(id: $id) {
      id
      name
      parentId
      parent {
        id
        name
        parentId
        __typename
      }
      __typename
    }
  }
`;
export const listFolders = /* GraphQL */ `
  query ListFolders(
    $id: ID
    $filter: ModelFolderFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listFolders(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        parentId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const foldersByParentId = /* GraphQL */ `
  query FoldersByParentId(
    $parentId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFolderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    foldersByParentId(
      parentId: $parentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        parentId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchFolders = /* GraphQL */ `
  query SearchFolders(
    $filter: SearchableFolderFilterInput
    $sort: [SearchableFolderSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableFolderAggregationInput]
  ) {
    searchFolders(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        parentId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getGroup = /* GraphQL */ `
  query GetGroup($id: ID!, $locationId: ID!) {
    getGroup(id: $id, locationId: $locationId) {
      id
      name
      division
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      createdAt
      crewMemberIds
      members {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      __typename
    }
  }
`;
export const listGroups = /* GraphQL */ `
  query ListGroups(
    $id: ID
    $locationId: ModelIDKeyConditionInput
    $filter: ModelGroupFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listGroups(
      id: $id
      locationId: $locationId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const groupByLocationId = /* GraphQL */ `
  query GroupByLocationId(
    $locationId: ID!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    groupByLocationId(
      locationId: $locationId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchGroups = /* GraphQL */ `
  query SearchGroups(
    $filter: SearchableGroupFilterInput
    $sort: [SearchableGroupSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableGroupAggregationInput]
  ) {
    searchGroups(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getLocation = /* GraphQL */ `
  query GetLocation($id: ID!) {
    getLocation(id: $id) {
      id
      name
      phoneNumber
      address
      address1
      city
      province
      postalCode
      maxDailyHours
      maxWeeklyHours
      utcOffset
      payPeriodStart
      syncTasks
      dailyTimeReportReceivers {
        email
        __typename
      }
      mediaTargetFilesize
      mediaCompression
      termsOfUseURL
      privacyURL
      supportURL
      __typename
    }
  }
`;
export const listLocations = /* GraphQL */ `
  query ListLocations(
    $id: ID
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLocations(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLongProcess = /* GraphQL */ `
  query GetLongProcess($id: ID!) {
    getLongProcess(id: $id) {
      id
      processName
      status
      params
      startedAt
      updatedAt
      userId
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      expiry
      __typename
    }
  }
`;
export const listLongProcesses = /* GraphQL */ `
  query ListLongProcesses(
    $id: ID
    $filter: ModelLongProcessFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLongProcesses(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        processName
        status
        params
        startedAt
        updatedAt
        userId
        expiry
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const longProcessByProcessName = /* GraphQL */ `
  query LongProcessByProcessName(
    $processName: String!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLongProcessFilterInput
    $limit: Int
    $nextToken: String
  ) {
    longProcessByProcessName(
      processName: $processName
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        processName
        status
        params
        startedAt
        updatedAt
        userId
        expiry
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const longProcessByStatus = /* GraphQL */ `
  query LongProcessByStatus(
    $status: LongProcessStatus!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLongProcessFilterInput
    $limit: Int
    $nextToken: String
  ) {
    longProcessByStatus(
      status: $status
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        processName
        status
        params
        startedAt
        updatedAt
        userId
        expiry
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const longProcessByUserId = /* GraphQL */ `
  query LongProcessByUserId(
    $userId: ID!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLongProcessFilterInput
    $limit: Int
    $nextToken: String
  ) {
    longProcessByUserId(
      userId: $userId
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        processName
        status
        params
        startedAt
        updatedAt
        userId
        expiry
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const longProcessByUserIdByStatus = /* GraphQL */ `
  query LongProcessByUserIdByStatus(
    $userId: ID!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLongProcessFilterInput
    $limit: Int
    $nextToken: String
  ) {
    longProcessByUserIdByStatus(
      userId: $userId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        processName
        status
        params
        startedAt
        updatedAt
        userId
        expiry
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchLongProcesses = /* GraphQL */ `
  query SearchLongProcesses(
    $filter: SearchableLongProcessFilterInput
    $sort: [SearchableLongProcessSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableLongProcessAggregationInput]
  ) {
    searchLongProcesses(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        processName
        status
        params
        startedAt
        updatedAt
        userId
        expiry
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getMedia = /* GraphQL */ `
  query GetMedia($id: ID!) {
    getMedia(id: $id) {
      id
      filename
      mediaType
      description
      sortKey
      dailyReportId
      dailyReport {
        id
        submissionDate
        summary
        isCompleted
        anyoneInjured
        qaqcCompleted
        siteSecured
        pdfKey
        locationId
        foremanId
        customerId
        userId
        type
        inspectionType
        foremanName
        customerName
        address
        taskArea
        weather
        inspectionQuestion
        foremanSignature
        safetySignature
        __typename
      }
      userId
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      createdAt
      customerId
      locationId
      __typename
    }
  }
`;
export const listMedia = /* GraphQL */ `
  query ListMedia(
    $id: ID
    $filter: ModelMediaFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMedia(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        filename
        mediaType
        description
        sortKey
        dailyReportId
        userId
        createdAt
        customerId
        locationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mediabyFilename = /* GraphQL */ `
  query MediabyFilename(
    $filename: String!
    $sortDirection: ModelSortDirection
    $filter: ModelMediaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    mediabyFilename(
      filename: $filename
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        filename
        mediaType
        description
        sortKey
        dailyReportId
        userId
        createdAt
        customerId
        locationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mediabyDailyReportId = /* GraphQL */ `
  query MediabyDailyReportId(
    $dailyReportId: ID!
    $sortKey: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMediaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    mediabyDailyReportId(
      dailyReportId: $dailyReportId
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        filename
        mediaType
        description
        sortKey
        dailyReportId
        userId
        createdAt
        customerId
        locationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mediaByUserId = /* GraphQL */ `
  query MediaByUserId(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelMediaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    mediaByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        filename
        mediaType
        description
        sortKey
        dailyReportId
        userId
        createdAt
        customerId
        locationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mediaByCreationDate = /* GraphQL */ `
  query MediaByCreationDate(
    $createdAt: AWSDateTime!
    $sortKey: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMediaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    mediaByCreationDate(
      createdAt: $createdAt
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        filename
        mediaType
        description
        sortKey
        dailyReportId
        userId
        createdAt
        customerId
        locationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mediaByCustomerId = /* GraphQL */ `
  query MediaByCustomerId(
    $customerId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMediaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    mediaByCustomerId(
      customerId: $customerId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        filename
        mediaType
        description
        sortKey
        dailyReportId
        userId
        createdAt
        customerId
        locationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mediaByLocationId = /* GraphQL */ `
  query MediaByLocationId(
    $locationId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelMediaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    mediaByLocationId(
      locationId: $locationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        filename
        mediaType
        description
        sortKey
        dailyReportId
        userId
        createdAt
        customerId
        locationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNotification = /* GraphQL */ `
  query GetNotification($id: ID!) {
    getNotification(id: $id) {
      id
      hasViewed
      status
      subject
      body
      content
      date
      expiry
      userId
      __typename
    }
  }
`;
export const listNotifications = /* GraphQL */ `
  query ListNotifications(
    $id: ID
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listNotifications(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        hasViewed
        status
        subject
        body
        content
        date
        expiry
        userId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const notificationsByUserId = /* GraphQL */ `
  query NotificationsByUserId(
    $userId: ID!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByUserId(
      userId: $userId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        hasViewed
        status
        subject
        body
        content
        date
        expiry
        userId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getQBSync = /* GraphQL */ `
  query GetQBSync($id: ID!) {
    getQBSync(id: $id) {
      id
      sessionId
      session {
        id
        locationId
        expiry
        createdAt
        __typename
      }
      task
      status
      data
      createdAt
      expiry
      __typename
    }
  }
`;
export const listQBSyncs = /* GraphQL */ `
  query ListQBSyncs(
    $id: ID
    $filter: ModelQBSyncFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listQBSyncs(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        sessionId
        task
        status
        data
        createdAt
        expiry
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const qbSyncBySessionId = /* GraphQL */ `
  query QbSyncBySessionId(
    $sessionId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQBSyncFilterInput
    $limit: Int
    $nextToken: String
  ) {
    qbSyncBySessionId(
      sessionId: $sessionId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sessionId
        task
        status
        data
        createdAt
        expiry
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRateOverride = /* GraphQL */ `
  query GetRateOverride($crewMemberId: ID!, $locationId: ID!) {
    getRateOverride(crewMemberId: $crewMemberId, locationId: $locationId) {
      crewMemberId
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      rate
      __typename
    }
  }
`;
export const listRateOverrides = /* GraphQL */ `
  query ListRateOverrides(
    $crewMemberId: ID
    $locationId: ModelIDKeyConditionInput
    $filter: ModelRateOverrideFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRateOverrides(
      crewMemberId: $crewMemberId
      locationId: $locationId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        crewMemberId
        locationId
        rate
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const rateOverrideByLocationId = /* GraphQL */ `
  query RateOverrideByLocationId(
    $locationId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRateOverrideFilterInput
    $limit: Int
    $nextToken: String
  ) {
    rateOverrideByLocationId(
      locationId: $locationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        crewMemberId
        locationId
        rate
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getScope = /* GraphQL */ `
  query GetScope($id: ID!, $locationId: ID!) {
    getScope(id: $id, locationId: $locationId) {
      id
      name
      fullName
      account
      active
      locationId
      __typename
    }
  }
`;
export const listScopes = /* GraphQL */ `
  query ListScopes(
    $id: ID
    $locationId: ModelIDKeyConditionInput
    $filter: ModelScopeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listScopes(
      id: $id
      locationId: $locationId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        fullName
        account
        active
        locationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const scopesByLocationId = /* GraphQL */ `
  query ScopesByLocationId(
    $locationId: ID!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelScopeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    scopesByLocationId(
      locationId: $locationId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        fullName
        account
        active
        locationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchScopes = /* GraphQL */ `
  query SearchScopes(
    $filter: SearchableScopeFilterInput
    $sort: [SearchableScopeSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableScopeAggregationInput]
  ) {
    searchScopes(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        fullName
        account
        active
        locationId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getSession = /* GraphQL */ `
  query GetSession($id: ID!) {
    getSession(id: $id) {
      id
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      expiry
      createdAt
      tasks {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listSessions = /* GraphQL */ `
  query ListSessions(
    $id: ID
    $filter: ModelSessionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSessions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        locationId
        expiry
        createdAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sessionByLocationId = /* GraphQL */ `
  query SessionByLocationId(
    $locationId: ID!
    $expiry: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sessionByLocationId(
      locationId: $locationId
      expiry: $expiry
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        expiry
        createdAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTimeEntry = /* GraphQL */ `
  query GetTimeEntry($id: ID!) {
    getTimeEntry(id: $id) {
      id
      date
      scopeId
      scope {
        id
        name
        fullName
        account
        active
        locationId
        __typename
      }
      hours
      adjustedHours {
        straightTime
        overtime
        __typename
      }
      isApproved
      timeSheetId
      timeSheet {
        id
        locationId
        customerId
        foremanId
        userId
        hours
        allApproved
        date
        isApproved
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      crewMemberId
      crewMember {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      status
      syncStatusMessage
      __typename
    }
  }
`;
export const listTimeEntries = /* GraphQL */ `
  query ListTimeEntries(
    $id: ID
    $filter: ModelTimeEntryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTimeEntries(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        date
        scopeId
        hours
        isApproved
        timeSheetId
        customerId
        crewMemberId
        locationId
        status
        syncStatusMessage
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const timeEntrybyScopeId = /* GraphQL */ `
  query TimeEntrybyScopeId(
    $scopeId: ID!
    $locationId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeEntryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeEntrybyScopeId(
      scopeId: $scopeId
      locationId: $locationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        date
        scopeId
        hours
        isApproved
        timeSheetId
        customerId
        crewMemberId
        locationId
        status
        syncStatusMessage
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const timeEntrybyTimeSheetId = /* GraphQL */ `
  query TimeEntrybyTimeSheetId(
    $timeSheetId: ID!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeEntryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeEntrybyTimeSheetId(
      timeSheetId: $timeSheetId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        date
        scopeId
        hours
        isApproved
        timeSheetId
        customerId
        crewMemberId
        locationId
        status
        syncStatusMessage
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const timeEntrybyCustomerId = /* GraphQL */ `
  query TimeEntrybyCustomerId(
    $customerId: ID!
    $locationId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeEntryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeEntrybyCustomerId(
      customerId: $customerId
      locationId: $locationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        date
        scopeId
        hours
        isApproved
        timeSheetId
        customerId
        crewMemberId
        locationId
        status
        syncStatusMessage
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const timeEntrybyCrewMemberId = /* GraphQL */ `
  query TimeEntrybyCrewMemberId(
    $crewMemberId: ID!
    $locationId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeEntryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeEntrybyCrewMemberId(
      crewMemberId: $crewMemberId
      locationId: $locationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        date
        scopeId
        hours
        isApproved
        timeSheetId
        customerId
        crewMemberId
        locationId
        status
        syncStatusMessage
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const timeEntrybyLocationId = /* GraphQL */ `
  query TimeEntrybyLocationId(
    $locationId: ID!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeEntryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeEntrybyLocationId(
      locationId: $locationId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        date
        scopeId
        hours
        isApproved
        timeSheetId
        customerId
        crewMemberId
        locationId
        status
        syncStatusMessage
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const timeEntrybyStatus = /* GraphQL */ `
  query TimeEntrybyStatus(
    $status: TimeEntryStatus!
    $locationId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeEntryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeEntrybyStatus(
      status: $status
      locationId: $locationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        date
        scopeId
        hours
        isApproved
        timeSheetId
        customerId
        crewMemberId
        locationId
        status
        syncStatusMessage
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTimeSheet = /* GraphQL */ `
  query GetTimeSheet($id: ID!) {
    getTimeSheet(id: $id) {
      id
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      timeEntries {
        nextToken
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      customers {
        id
        number
        name
        active
        locationId
        __typename
      }
      foremanId
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      userId
      createdBy {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      hours
      allApproved
      date
      isApproved
      __typename
    }
  }
`;
export const listTimeSheets = /* GraphQL */ `
  query ListTimeSheets(
    $id: ID
    $filter: ModelTimeSheetFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTimeSheets(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        locationId
        customerId
        foremanId
        userId
        hours
        allApproved
        date
        isApproved
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const timeSheetByLocationId = /* GraphQL */ `
  query TimeSheetByLocationId(
    $locationId: ID!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeSheetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeSheetByLocationId(
      locationId: $locationId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        customerId
        foremanId
        userId
        hours
        allApproved
        date
        isApproved
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const timeSheetByCustomerId = /* GraphQL */ `
  query TimeSheetByCustomerId(
    $customerId: ID!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeSheetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeSheetByCustomerId(
      customerId: $customerId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        customerId
        foremanId
        userId
        hours
        allApproved
        date
        isApproved
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const timeSheetByForemanId = /* GraphQL */ `
  query TimeSheetByForemanId(
    $foremanId: ID!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeSheetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeSheetByForemanId(
      foremanId: $foremanId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        customerId
        foremanId
        userId
        hours
        allApproved
        date
        isApproved
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const timeSheetByUserId = /* GraphQL */ `
  query TimeSheetByUserId(
    $userId: ID!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeSheetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeSheetByUserId(
      userId: $userId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        customerId
        foremanId
        userId
        hours
        allApproved
        date
        isApproved
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      email
      firstName
      lastName
      phoneNumber
      expoPushToken
      isNotificationEnabled
      role
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      crewMemberId
      crewMember {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      hasDivisionAccess
      groups {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      divisions {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $id: ID
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUsers(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userByEmail = /* GraphQL */ `
  query UserByEmail(
    $email: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userByExpoPushToken = /* GraphQL */ `
  query UserByExpoPushToken(
    $expoPushToken: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByExpoPushToken(
      expoPushToken: $expoPushToken
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const usersByRole = /* GraphQL */ `
  query UsersByRole(
    $role: Role!
    $locationId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByRole(
      role: $role
      locationId: $locationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const usersByLocationId = /* GraphQL */ `
  query UsersByLocationId(
    $locationId: ID!
    $role: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByLocationId(
      locationId: $locationId
      role: $role
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userByCrewMemberId = /* GraphQL */ `
  query UserByCrewMemberId(
    $crewMemberId: ID!
    $locationId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByCrewMemberId(
      crewMemberId: $crewMemberId
      locationId: $locationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchUsers = /* GraphQL */ `
  query SearchUsers(
    $filter: SearchableUserFilterInput
    $sort: [SearchableUserSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableUserAggregationInput]
  ) {
    searchUsers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
